export interface ICompanyGroupListItemCompany {
    id: string;
    name: string;
    disabled: boolean;
}

export class CompanyGroupListItemCompany implements ICompanyGroupListItemCompany {
    id: string;
    name: string;
    disabled: boolean;

    constructor();
    constructor(obj: ICompanyGroupListItemCompany);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.disabled = obj && obj.disabled || false;
    }
}